import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    searchPlaceholder: translate({ id: 'setup.routing.segmentFilterPlaceholder' }),
    yourSegments: translate({ id: 'setup.routing.list.segments.yourSegments' }),
    importKML: translate({ id: 'global.importKML' }),
    createNew: translate({ id: 'setup.routing.list.segments.createNew' }),
    entitiesCount: (count: number, selected: number): string =>
      translate({
        id:
          selected > 0
            ? 'setup.routing.list.segments.footerCountWithSelection'
            : 'setup.routing.list.segments.footerCount',
        values: { count, selected },
      }),
    selectBtn: (allSelected: boolean): string =>
      translate({ id: allSelected ? 'global.deselectAll' : 'global.selectAll' }),
    visibilityBtn: (someVisible?: boolean): string =>
      translate({
        id: someVisible ? 'global.hideAll' : 'global.showAll',
      }),

    importKMLFailed: translate({ id: 'global.importKML.failed' }),

    noEntries: {
      title: translate({ id: 'routing.list.noEntries.title' }),
      description: translate({ id: 'routing.list.noEntries.description' }),
      action: translate({ id: 'routing.list.noEntries.action' }),
    },
    noResults: {
      title: translate({ id: 'routing.list.noResults.title' }),
      description: translate({ id: 'routing.list.noResults.description' }),
    },
  }))

  return api
}
